import React from 'react';
import { withTranslation } from 'react-i18next';
import { Icon } from '@workboard/action-item';
import { getAiTypeAttributes } from '../../board/utils';
import SearchUtils from './search-util';

class SearchResultsComp extends React.Component {
  constructor(props) {
    super(props);
    this.clickRow = this.clickRow.bind(this);
    this.openNewWindow = this.openNewWindow.bind(this);
    this.openWindow = this.openWindow.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleResultRowEvent = this.handleResultRowEvent.bind(this);
    this.generateSearchEvent = this.generateSearchEvent.bind(this);
  }

  componentDidMount() {
    this.refs.resultScroll.addEventListener('scroll', () => {
      if (
        this.refs.resultScroll.scrollTop + this.refs.resultScroll.clientHeight >=
        this.refs.resultScroll.scrollHeight
      ) {
        // console.log('window scro;;');
        this.props.loadMoreSearchResults();
      }
    });
    document.addEventListener('keydown', this.handleResultRowEvent);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleResultRowEvent);
  }

  handleResultRowEvent(e) {
    if (e) {
      let targetEle = e.target;
      let code = e.which ? e.which : e.keyCode;
      if (code == 13 && targetEle.classList.contains('search-result-row')) {
        let parentNode = targetEle.parentNode; //search-result-table
        if (parentNode.classList.contains('search-result-table')) {
          targetEle.click();
        }
      }
    }
  }

  closeModal() {
    if (this.props.closeModal) {
      this.props.closeModal();
    }
  }

  openNewWindow(url) {
    window.open(url, '_blank');
  }

  openWindow(url, ctrlClicked = false) {
    if (ctrlClicked) {
      this.openNewWindow(url);
    } else {
      this.closeModal();
      window.location.href = url;
    }
  }

  clickRow(e, item) {
    let type = item._type;
    let url = wbConfig.baseUrl;
    const source = item;
    // const index = item._index;
    const ctrlClicked = e.ctrlKey || e.metaKey;
    let categoryId = this.props.categoryId;
    this.generateSearchEvent(type);
    if (type == 'comment' && source.obj_type == 'goal') {
      type = 'goalcomment';
    }
    if (type == 'activity' || type == 'comment') {
      let id = type == 'activity' ? source.id : source.obj_id;
      if (ctrlClicked) {
        this.openNewWindow(url + '/activity/mywork?do=popup&id=' + id);
      } else {
        this.closeModal();
        url = url + '/activity/ActionItemDetails?id=' + id;
        openFullPopUp(aiFullViewPopUp, url, this);
      }
    } else if (type == 'goal') {
      if (ctrlClicked) {
        this.openNewWindow(url + '/okrs/objectives/' + source.id);
      } else {
        this.closeModal();
        var params = {};
        params.id = source.id;
        viewGoalDetailsPage(undefined, params);
      }
    } else if (type == 'metric') {
      if (ctrlClicked) {
        this.openNewWindow(url + '/goal/krDetails?id=' + source.id);
      } else {
        this.closeModal();
        krDetailPage(source.id);
      }
    } else if (type == 'goalcomment') {
      if (ctrlClicked) {
        url += '/okrs/objectives/' + source.obj_id;
        this.openNewWindow(url);
      } else {
        this.closeModal();
        var params = {};
        params.id = source.obj_id;
        params.commentMenuActive = 1;
        viewGoalDetailsPage(undefined, params);
      }
    } else if (type == 'meeting' || type == 'meetingtopic' || type == 'meetingtake') {
      let id = type == 'meeting' ? source.id : source.meeting_id;
      url = url + '/meeting/meetingDetails?id=' + id;
      this.openWindow(url, ctrlClicked);
    } else if (type == 'user') {
      url = url + '/memberProfile/index?id=' + source.id;
      this.openWindow(url, ctrlClicked);
    } else if (type == 'workstream') {
      url = url + '/activity/workstreams?id=' + source.id;
      this.openWindow(url, ctrlClicked);
    } else if (type == 'team') {
      url = url + '/activity/workstreams?teamView&teamId=' + source.id;
      this.openWindow(url, ctrlClicked);
    } else if (type == 'rbr') {
      url = url + '/rbr/index?id=' + source.id;
      this.openWindow(url, ctrlClicked);
    } else if (type == 'team_goal' || type == 'user_goal') {
      let params = type == 'team_goal' ? 'teamId=' + source.id : 'userId=' + source.id;
      if (categoryId != '') {
        params += '&categories=' + categoryId;
      }
      url = url + '/goal/teamGoal?js=1&' + params;
      this.openWindow(url, ctrlClicked);
    } else if (type == 'user_metric') {
      url = url + '/goal/getPersonKrs?id=' + source.encrId + '&refSrc=PERSON_KR';
      this.openWindow(url, ctrlClicked);
    } else if (type == 'kpi') {
      if (ctrlClicked) {
        this.openNewWindow(url + '/okrs?openModal=viewKpi&kpiId=' + source.id);
      } else {
        this.closeModal();
        if (typeof window.openKpiViewModal === 'function') {
          window.openKpiViewModal(source.id, 'globalSearch');
        }
      }
    } else if (type == 'team_kpi' || type == 'user_kpi') {
      // TODO: Update with actual KPI page URLs when available
      let params = type == 'team_kpi' ? 'teamId=' + source.id : 'userId=' + source.id;
      url = url + '/kpi/list?js=1&' + params;
    }
  }

  generateSearchEvent(eventType) {
    var type = '';
    switch (eventType) {
      case 'team':
      case 'workstream':
      case 'meeting':
      case 'rbr':
        type = eventType.toUpperCase();
        break;
      case 'activity':
        type = 'AI';
        break;
      case 'goal':
        type = 'OKR';
        break;
      case 'goalcomment':
        type = 'KR_OKR_COMMENTS';
        break;
      case 'team_goal':
        type = 'TEAM_OKR';
        break;
      case 'metric':
        type = 'KR';
        break;
      case 'meetingtopic':
        type = 'MEETING_TOPICS';
        break;
      case 'user':
        type = 'PERSON_PROFILE';
        break;
      case 'user_goal':
        type = 'PERSON_OKR';
        break;
      case 'user_metric':
        type = 'PERSON_KR';
        break;
      case 'kpi':
        type = 'KPI';
        break;
      case 'team_kpi':
        type = 'TEAM_KPI';
        break;
      case 'user_kpi':
        type = 'PERSON_KPI';
        break;
      default:
        type = 'UNKNOWN';
        break;
    }

    SearchUtils.pushGlobalSearchEvent('GLOBAL_SEARCH_RESULTS_VIEWED', { type });
  }

  markUpHtml(text) {
    return { __html: text };
  }

  renderResult(result, i = 0) {
    const { t } = this.props;
    const type = result._type;
    const source = result;
    const key = `${type}-${source.id}`;
    let tabProps = { tabIndex: i + 1, 'data-type': type, 'data-id': source.id };
    if (type == 'user') {
      return (
        <div
          key={key}
          {...tabProps}
          className="search-result-row main-bucket-row "
          onClick={(e) => this.clickRow(e, result)}
        >
          <div className="search-result-col search-result-icon-col">
            <img src={source.picture} width="30" height="30" style={{ borderRadius: '50%' }} />
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <span className="font-weight-bold">{t("{{name}}'s Profile Page", { name: source.description })}</span>
          </div>
        </div>
      );
    } else if (type == 'team') {
      return (
        <div
          key={key}
          {...tabProps}
          className="search-result-row main-bucket-row "
          onClick={(e) => this.clickRow(e, result)}
        >
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-outline-people-24px_bluegreen "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div>
              <span className="font-weight-bold">{t("{{name}}'s Team Page", { name: source.description })}</span>
              {source.state == 0 && (
                <>
                  <span className="dotClass">&nbsp;</span>
                  <span className="archived-font">{t('Archived')}</span>
                </>
              )}
            </div>
            <div className="subtext">{source.owner_name}</div>
          </div>
        </div>
      );
    } else if (type == 'team_goal' || type == 'user_goal') {
      return (
        <div
          key={key}
          {...tabProps}
          className="search-result-row main-bucket-row "
          onClick={(e) => this.clickRow(e, result)}
        >
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-outline-bar_chart-24px-bluegreen "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <span className="font-weight-bold">{`${source.description}'s ${t('OKRs')} `}</span>
            {source.state == 0 && (
              <>
                <span className="dotClass">&nbsp;</span>
                <span className="archived-font">{t('Archived')}</span>
              </>
            )}
          </div>
        </div>
      );
    } else if (type == 'user_metric') {
      return (
        <div
          key={key}
          {...tabProps}
          className="search-result-row main-bucket-row "
          onClick={(e) => this.clickRow(e, result)}
        >
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-kr-24px-bluegreen "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div className="font-weight-bold">{`${source.description}'s ${t('Key Results')}`}</div>
          </div>
        </div>
      );
    } else if (type == 'meeting') {
      if (source.type == '1') {
        return (
          <div
            key={key}
            {...tabProps}
            className="search-result-row main-bucket-row "
            onClick={(e) => this.clickRow(e, result)}
          >
            <div className="search-result-col search-result-icon-col">
              <i className="icon icon-meetings_24px-bluegreen"></i>
            </div>
            <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
              <div className="font-weight-bold">{`1on1 with ${source.description}`}</div>
            </div>
          </div>
        );
      } else {
        let text = source.interval > 0 ? 'Recurring' : source.dateText;
        return (
          <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
            <div className="search-result-col search-result-icon-col">
              <i className="icon icon-decision_24px "></i>
            </div>
            <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
              <div dangerouslySetInnerHTML={this.markUpHtml(source.description)} />
              <div className="subtext">
                {source.owner_name}
                {text ? <span className="dotClass"></span> : ''}
                {text}
              </div>
            </div>
          </div>
        );
      }
    } else if (type == 'goal') {
      let text = source.team_name ? source.team_name + ': ' + source.owner_name : source.owner_name;
      return (
        <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-outline-bar_chart-24px "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div> {source.description} </div>
            <div className="subtext">
              {text}
              {source.dateText ? <span className="dotClass"></span> : ''}
              {source.dateText}
            </div>
          </div>
        </div>
      );
    } else if (type == 'metric') {
      let text = source.real_owner_name || source.source_from || source.owner_name;
      return (
        <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-KR-24px"></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div> {source.description} </div>
            <div className="subtext">
              {text}
              {source.goal_name ? <span className="dotClass"></span> : ''}
              {source.goal_name}
              {source.dateText ? <span className="dotClass"></span> : ''}
              {source.dateText}
            </div>
          </div>
        </div>
      );
    } else if (type === 'team_kpi' || type === 'user_kpi') {
      return (
        <div
          key={key}
          {...tabProps}
          className="search-result-row main-bucket-row "
          onClick={(e) => this.clickRow(e, result)}
        >
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-kpi-24px"></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <span className="font-weight-bold">{`${source.description}'s ${t('KPIs')} `}</span>
            {source.state == 0 && (
              <>
                <span className="dotClass">&nbsp;</span>
                <span className="archived-font">{t('Archived')}</span>
              </>
            )}
          </div>
        </div>
      );
    } else if (type === 'kpi') {
      const ownerName = Array.isArray(source.owner_names) ? source.owner_names.join(', ') : source.owner_name;
      const teamName = Array.isArray(source.team_names) ? source.team_names.join(', ') : source.team_name;
      let text = teamName ? teamName + ': ' + ownerName : ownerName;

      return (
        <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-kpi-24px"></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div> {source.name} </div>
            <div className="subtext">
              {text}
            </div>
          </div>
        </div>
      );
    } else if (type == 'meetingtopic' || type == 'meetingtake') {
      let text = type == 'meetingtopic' ? 'Topic' : 'Takeaway';
      text = text + ' on ' + (source.type == 1 ? '1on1' : 'meeting') + ': ' + source.meeting_name;
      return (
        <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-decision_24px "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div className="subtext italic-text">{text}</div>
            <div dangerouslySetInnerHTML={this.markUpHtml(source.description)} />
            <div className="subtext">
              {source.owner_name}
              {source.dateText ? <span className="dotClass"></span> : ''}
              {source.dateText}
            </div>
          </div>
        </div>
      );
    } else if (type == 'activity') {
      let text = source.ws_name ? source.ws_name + ': ' + source.owner_name : source.owner_name;
      const attributes = getAiTypeAttributes(Number(source.type));

      return (
        <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col" title={attributes?.label}>
            <Icon name={attributes?.icons?.component} fill="var(--gray-500)" />
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div dangerouslySetInnerHTML={this.markUpHtml(source.description)} />
            <div className="subtext">
              {text}
              {source.dateText ? <span className="dotClass"></span> : ''}
              {source.dateText}
            </div>
          </div>
        </div>
      );
    } else if (type == 'workstream') {
      return (
        <div key={key} {...tabProps} className="search-result-row" onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-outline-waves-24px "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div dangerouslySetInnerHTML={this.markUpHtml(source.description)} />
            <div className="subtext">{`${source.owner_name}'s Workstream`}</div>
          </div>
        </div>
      );
    } else if (type == 'rbr') {
      return (
        <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-biz_review-24px "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div className="" dangerouslySetInnerHTML={this.markUpHtml(source.description)} />
            <div className="subtext">{`${source.owner_name}'s Biz Review`}</div>
          </div>
        </div>
      );
    } else if (type == 'comment') {
      let text = 'Comment on: ' + source.ai_name;
      return (
        <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-ic_chat_bubble_outline_24px "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div className="subtext italic-text">{text}</div>
            <div className="remove-inline-position" dangerouslySetInnerHTML={this.markUpHtml(source.description)} />
            <div className="subtext">
              {source.owner_name}
              {source.dateText ? <span className="dotClass"></span> : ''}
              {source.dateText}
            </div>
          </div>
        </div>
      );
    } else if (type == 'goalcomment') {
      let text = 'Comment on: ' + source.goal_name;
      return (
        <div key={key} {...tabProps} className="search-result-row " onClick={(e) => this.clickRow(e, result)}>
          <div className="search-result-col search-result-icon-col">
            <i className="icon icon-ic_chat_bubble_outline_24px "></i>
          </div>
          <div className="search-result-col search-result-text-col" data-testid="search-result-col-testid">
            <div className="subtext italic-text">{text}</div>
            <div dangerouslySetInnerHTML={this.markUpHtml(source.description)} />
            <div className="subtext">
              {source.owner_name}
              {source.dateText ? <span className="dotClass"></span> : ''}
              {source.dateText}
            </div>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="search-result-table-wrapper" ref="resultScroll">
        <div className="search-result-table search-result-hover-table">
          {this.props.results.map((result, index) => this.renderResult(result, index))}
        </div>
      </div>
    );
  }
}

SearchResultsComp.defaultProps = {
  results: [],
  loadMoreSearchResults: null,
  closeModal: null,
};

export default withTranslation()(SearchResultsComp);
